<template>
  <div>
    Extend me!
  </div>
</template>

<script>
export default {
  data () {
    return {
      id: 'unknown',
    }
  },

  computed: {

    active () {
      return this.currentView.pane === this.id
    },

    currentView () {
      return this.$store.getters['account/current']
    },

    oldView () {
      return this.$store.getters['account/from']
    },

    user () {
      return this.$store.getters['user/account']
    },

    wasActive () {
      return this.oldView.pane === this.id
    },

  },

  methods: {

    showPanel (pane, page, subpage) {
      if(!window.location.href.includes(pane)) {
        window.history.pushState("state obj or string", "url", window.location.href+"#"+pane);
      }
      subpage = (typeof subpage == 'undefined') ? 'index' : subpage
      this.$store.commit('account/navigateTo', { pane: pane, page: page, subpage: subpage })
    },

  }
}
</script>
